module.exports = __webpack_public_path__ + "static/media/SCG-Add-Venture.db299271.png";